export const byParent = (jurisdictions, parentId) =>
  jurisdictions.filter(jurisdiction =>
    (jurisdiction.parent === parentId) || jurisdiction.id === parentId);

export const parentJurisdictions = jurisdictions =>
  jurisdictions.filter(jurisdiction => (jurisdiction.parent === null));
